module.exports = __webpack_public_path__ + "img/hout en steen.e5d2f21b.jpg";